<template>
  <div :class="['main-page lawFirm', { xiaodu: isXiaodu }]">
    <Menu title="律所查询"
          :home="true">
      <template slot="left-link">
        <a href="javascript:;"
           @click="goPrevious()"></a>
      </template>
    </Menu>
    <div class="container-flex lawfirm-box">

      <div class="lawfirm-container">
        <div class="left">
          <div class="sider">
            <div class="ht">区域选择</div>
            <div class="area-content">
              <a :class="currentresidencecode == currentareacode ? 'btn btn-primary btn-lg' : 'btn btn-default btn-lg'"
                 @click="changeResidence(currentareacode)">全部</a>
              <a :class="currentresidencecode == key ? 'btn btn-primary btn-lg' : 'btn btn-default btn-lg'"
                 v-for="(value, key) in residence"
                 :key="'key-' + key"
                 @click="changeResidence(key)">{{ value.name }}</a>
              <a class="btn btn-default btn-lg"
                 @click="show_select_areacode = true">其他州市</a>
            </div>
            <div class="ht">律所搜索</div>
            <div class="search-content">
              <input type="text"
                     class="form-control input-lg"
                     placeholder="请输入律所名称"
                     v-model="searchlawfirm"
                     @keyup.enter="getSearchedLawFirm">
              <button type="submit"
                      class="btn btn-primary btn-lg"
                      @click="getSearchedLawFirm">搜索</button>
            </div>
          </div>
        </div>
        <div class="right"
             v-infinite-scroll="loadMore"
             :infinite-scroll-disabled="busy"
             infinite-scroll-distance="10">
          <div class="lawfirm-list">

            <a href="javascript:void(0)"
               class="item"
               v-for="(lawfirm, index) in currentlawfirmlist"
               :key="'key-' + index"
               @click="toLawfirmDetail(lawfirm)">
              <div class="content">
                <div class="name">{{ lawfirm.zwmc }}</div>
                <div>{{ lawfirm.lsdz }}<br>
                  <span v-if="lawfirm.tell">电话：{{ lawfirm.tell }}</span>
                  <span v-else>电话：暂无</span>
                </div>
              </div>
              <i class="glyphicon glyphicon-chevron-right"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="lawfirm-detail"
           v-if="step == 1">
        <div class="lawfirm-detail-content"
             :style="only_lawfirm_css">
          <div class="name">{{ currentlawfirm.zwmc }}</div>

          <div class="info"
               v-html="currentlawfirm.lsdz">
          </div>
          <div class="more">
            <a href="javascript:void(0)"
               class="btn btn-primary"
               @click="step = 2"
               v-if="currentlawfirm.content">律所详情</a>
          </div>
          <div class="contact">
            <div>
              组织形式：{{ currentlawfirm.zzxs }}
            </div>
            <div>
              批准设立时间：{{ currentlawfirm.pzslsj }}
            </div>
            <div>
              统一社会信用代码：{{ currentlawfirm.tyshxydm }}
            </div>
            <div>
              {{ currentlawfirm.address }}
            </div>
            <div v-if="currentlawfirm.tell">

              电话：{{ currentlawfirm.tell }}</div>
            <div v-else>

              电话：暂无</div>
          </div>
          <div class="ht">律所律师</div>

          <div class="lawyer-list">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-4"
                     v-for="(lawyer, index) in currentlawyerlist"
                     :key="'key-' + index">
                  <a href="javascript:void(0)"
                     class="item"
                     @click="toLawyerDetail(lawyer)">
                    <div v-if="lawyer.zp"
                         class="imgs"
                         :style="'background-image:url(' + lawyer.zp + ')'"></div>
                    <div v-else
                         class="imgs"
                         style="background-image:url('/img/ui/lawyer_avatar.png')"></div>
                    <div class="c">
                      <div class="lawyer-name">{{ lawyer.xm }}</div>
                      <div class="lawyer-tell"
                           v-if="lawyer.lxfs">联系电话：{{ lawyer.lxfs }}</div>
                      <div class="lawyer-tell"
                           v-else>联系电话：暂无</div>
                      <div class="lawyer-intro">
                        <!-- 擅长专业：{{ lawyer.adept }} -->
                        执业证号：{{ lawyer.zyzh }}
                      </div>
                      <div class="lawyer-intro">
                        <!-- 擅长专业：{{ lawyer.adept }} -->
                        执业类别：{{ lawyer.zylb }}
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mask"
             @click="step = 0"></div>
      </div>
      <div class="lawfirm-about"
           v-if="step == 2">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="ht">{{ currentlawfirm.zwmc }}</div>
              <div class="detail"
                   v-html="currentlawfirm.lsdz">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lawyer-about"
           v-if="step == 3">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="lawyer">
                <div class="content">
                  <div v-if="currentlawyer.zp"
                       class="imgs"
                       :style="'background-image:url(' + currentlawyer.zp + ')'">
                  </div>
                  <div v-else
                       class="imgs"
                       style="background-image:url('/img/ui/lawyer_avatar.png')"></div>
                  <div class="intro">
                    <strong class="name">{{ currentlawyer.xm }}</strong>
                    <div class="rate">
                      <div>
                        <i class="glyphicon glyphicon-star"
                           :key="item"
                           v-for="item in 5"
                           :class="{ on: item < 6 }"></i>
                      </div>
                      <span>电话：{{ currentlawyer.lxfs }}</span>
                    </div>
                    <div class="lawfir">{{ currentlawfirm.zwmc }}</div>
                  </div>
                  <div class="sc">
                    <ul>
                      <li>执业证号：{{ currentlawyer.zyzh }}</li>
                      <li style="width:100%">擅长专业：{{ currentlawyer.adept || '暂无' }}</li>
                      <li style="width:100%">执业类别：{{ currentlawyer.zylb || '暂无' }}</li>
                      <li style="width:100%">所在律所：{{ currentlawfirm.zwmc || '暂无' }}</li>
                      <li style="width:100%">联系地址：{{ currentlawfirm.lsdz || '暂无' }}</li>
                    </ul>
                  </div>
                </div>
                <div class="body"
                     v-if="currentlawyer.desc">
                  <div class="ht">
                    律师简介
                  </div>
                  <div class="detail"
                       v-html="currentlawyer.desc">
                  </div>
                </div>
                <a href="javascript:void(0)"
                   class="btn btn-success btn-zxls"
                   @click="getLawyerTel">咨询该律师</a>
                <Dialogs v-model="dialog">
                  <div class="lawyer-intro-rate">
                    <div class="lawyer-intro--info">
                      <div class="name">{{ currentlawyer.xm }} 律师</div>
                      <div class="tel">
                        咨询电话
                        <strong>{{ currentlawyer.lxfs }}</strong>
                      </div>
                    </div>
                    <div class="lawyer-intro--tip">
                      咨询完成后可对律师服务进行评价打分
                    </div>
                    <div class="lawyer-intro--rates">
                      <Rate title="服务态度"
                            v-model="rate.lawyerAttitude" />
                      <Rate title="专业度"
                            v-model="rate.lawyerQuality" />
                    </div>
                  </div>

                  <template slot="foot">
                    <a :class="rate.lawyerAttitude > 0 && rate.lawyerQuality > 0 ? 'lp-btn large primary' : 'lp-btn large default'"
                       @click="updateRate"
                       class="submit-btn">提交评价</a>
                    <a class="lp-btn large default submit-btn"
                       @click="closeRate">不评价</a>
                  </template>
                </Dialogs>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="select_area"
           v-if="show_select_areacode">
        <div class="wrap">
          <div class="ht">请选择地区</div>
          <div class="content">
            <a v-for="(item, key) in rootArea"
               :key="'key-' + key"
               @click="getInitialItem(key)">
              <span>{{ item.name }}</span>
            </a>
          </div>
        </div>
      </div>
      <Alert v-if="alert.show"
             :info="alert.info"
             :recall="alert.recall"
             @setClose="value => alert.show = value " />
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Dialogs from '@/components/Dialog'
import Alert from '@/components/Alert'
import Rate from '@/components/Rate'
import api from '@/datas/js/api'
import { LAWFIRM_INQUIRE } from '../datas/constants/statistics.js'
export default {
  data () {
    return {
      isXiaodu: localStorage.getItem('xiaodu') || false,
      config: '',
      step: 0,
      residence: {},
      currentlawfirmlist: [],
      currentlawfirm: {},
      currentlawyerlist: [],
      currentlawyer: {},
      currentresidencecode: 0,
      currentresidencevalue: '',
      currentareacode: 0,
      searchlawfirm: '',
      checkedlawfirm: '',
      searchedlawfirm: [],
      search_flag: false,
      show_select_areacode: false,
      busy: false,
      allcount: 0,
      page: 1,
      pageSize: 1,
      dialog: {
        maskClose: true,
        show: false
      },
      rate: {
        isRate: false,
        lawyerAttitude: -1,
        lawyerQuality: -1
      },
      alert: {
        info: '',
        show: false,
        recall: () => { }
      }
    }
  },
  async mounted () {
    let webCode = this.web_code
    console.log('webCode', webCode)
    // let webCode = this.$root.config.web_code
    // const point = this.$root.point
    const point = this.$store.state.device.point
    this.$root.getStatistics(LAWFIRM_INQUIRE)
    if (point && point.config) {
      this.config = JSON.parse(point.config)
      if (this.config && this.config.lawfrim_filter) {
        this.step = 1
      }
    }
    await this.getInitialItem(webCode)
    if (this.config && this.config.lawfrim_filter) {
      await this.changeResidence(this.config.lawfirm_filter_code)
      this.toLawfirmDetail(this.currentlawfirmlist[0])
    }
  },
  computed: {
    only_lawfirm_css () {
      const c = this.config
      return c && c.lawfrim_filter ? 'left:0;padding:40px 200px' : 'left:30%'
    },
    rootArea () {
      return this.$store.state.device.area
    },
    web_code () {
      return this.$store.state.device.config.web_code
    }
  },
  methods: {
    updateRate () {
      const { lawyerAttitude, lawyerQuality, isRate } = this.rate
      if (lawyerAttitude > 0 && lawyerQuality > 0 && !isRate) {
        this.rate.isRate = true
        this.alert = {
          show: true,
          info: '评价成功！',
          recall: this.closeRate
        }
      }
    },
    closeRate () {
      this.dialog.show = false
      this.rate = {
        isRate: false,
        lawyerAttitude: -1,
        lawyerQuality: -1
      }
    },
    getLawyerTel () {
      this.dialog.show = true
    },
    goback () {
      if (this.step > 1) {
        this.step = 1
      }
    },
    async changeResidence (key) {
      this.currentlawfirmlist = []
      this.page = 1
      this.search_flag = false
      this.currentresidencecode = key
      if (key === this.currentareacode) {
        this.currentresidencevalue = this.rootArea[key].alias
      } else {
        this.currentresidencevalue = this.residence[key].name
      }
      await this.getNewItem(key)
    },
    async getInitialItem (webCode) {
      this.$loading.show()
      this.currentresidencevalue = this.rootArea[webCode].alias || ''
      this.currentresidencecode = webCode
      this.currentareacode = webCode
      if (Object.keys(this.residence).length) { // 切换大地区时判断，不为空则先清空
        for (let key in this.residence) {
          delete this.residence[key]
        }
      }
      this.show_select_areacode = false
      for (let i in this.rootArea[webCode].children) {
        this.residence[i] = this.rootArea[webCode].children[i]
      }
      let data = await this.$get(api.lawfirm + `?code=${webCode}&zwmc=${this.searchlawfirm}&per_page=10&page=${this.page}`)
      this.allcount = data.result.count
      this.pageSize = data.result.num_pages
      let filterData = this.getFilterItem(data.result.data)
      this.currentlawfirmlist.push(...filterData)
      this.$loading.hide()
    },
    async getLawyer (lawfirm) {
      let data = await this.$get(api.employee + `?firm=${lawfirm.bh}&per_page=99&page=1`)
      this.currentlawyerlist = data.result.data
    },
    async getNewItem (key) {
      this.$loading.show()
      if (key === '530100') {
        key = ''
      }
      let data = await this.$get(api.lawfirm + `?code=${key}&zwmc=${this.searchlawfirm}&per_page=10&page=${this.page}`)
      this.allcount = data.result.count
      this.pageSize = data.result.num_pages
      this.currentlawfirmlist = this.getFilterItem(data.result.data)
      this.$loading.hide()
    },
    /**
     * 过滤律师事务所
     * 例子，在对应的终端机下面添加过滤律所名称和律所所在区域，可在当前区域过滤只显示特定的律所
     * {
        "lawfrim_filter":["5abb63ffcf339859c2f3e779"],
        "lawfirm_filter_code":"532504"
        }
     */
    getFilterItem (data) {
      let point = this.$root.point
      let newdata = data
      if (point && point.config) {
        let config = JSON.parse(point.config)
        if (config.lawfrim_filter) {
          if (config.lawfirm_filter_code === this.currentresidencecode) {
            newdata = data.filter(item => {
              if (config.lawfrim_filter.includes(item.id)) {
                return item
              }
            })
          }
        }
      }
      return newdata
    },
    async getSearchedLawFirm () {
      this.searchlawfirm = this.searchlawfirm.replace(' ', '')
      if (this.searchlawfirm.length > 1) {
        // let reg = /[\u4e00-\u9fa5]/
        // let info = this.searchlawfirm
        // for (let char of this.searchlawfirm) {
        //   if (!reg.test(char)) {
        //     info = info.replace(char, '')
        //     this.searchlawfirm = this.searchlawfirm.replace(char, '')
        //   }
        // }
        // if (info.length === 0) {
        //   return
        // }
        this.search_flag = true
        this.searchedlawfirm.length = 0
        this.checkedlawfirm = this.searchlawfirm
        this.$loading.show()
        let data = await this.$get(api.searchLawfirm + `?code=${this.currentareacode}&zwmc=${this.searchlawfirm}&per_page=10&page=${this.page}`)
        // for (let i = 0; i < data.result.data.length; i++) {
        //   if (data.result.data[i].name.includes(this.checkedlawfirm)) {
        //     this.searchedlawfirm.push(data.result.data[i])
        //   }
        // }
        this.searchedlawfirm = data.result.data
        this.currentlawfirmlist = this.searchedlawfirm
        this.allcount = data.result.count
        this.pageSize = data.result.num_pages
        this.$loading.hide()
      }
    },
    loadMore () {
      if (this.page < this.pageSize && !this.busy) {
        this.page = this.page === 1 ? 2 : this.page
        console.log('当前页', this.page)
        this.$loading.show()
        this.busy = true
        var that = this
        setTimeout(async () => {
          let data = await this.$get(api.searchLawfirm + `?code=${this.currentareacode}&zwmc=${this.searchlawfirm}&per_page=10&page=${this.page}`)
          this.allcount = data.result.count
          this.pageSize = data.result.num_pages
          let filterData = this.getFilterItem(data.result.data)
          this.currentlawfirmlist.push(...filterData)
          that.page++
          that.busy = false
          await this.$loading.hide()
        }, 1000)
      }
    },
    toLawfirmDetail (lawfirm) {
      this.step = 1
      this.currentlawfirm = lawfirm
      this.getLawyer(this.currentlawfirm)
    },
    toLawyerDetail (lawyer) {
      this.step = 3
      this.currentlawyer = lawyer
    },
    goPrevious () {
      this.step === 0 ? this.$router.go(-1) : this.step = 1
    }
  },
  watch: {
    searchlawfirm () {
      this.searchlawfirm = this.searchlawfirm.replace(' ', '')
      if (this.searchlawfirm) {
        this.getSearchedLawFirm()
      } else {
        this.search_flag = false
      }
    }
  },
  components: {
    Menu,
    Dialogs,
    Rate,
    Alert
  }
}
</script>
<style lang="stylus">
.lawfirm-box
  overflow-y hidden
.select_area
  height 100vh
  display flex
  justify-content center
  align-items center
  position fixed
  left 0
  top 0
  right 0
  bottom 0
  z-index 10000
  background rgba(0, 0, 0, 0.5)
  .wrap
    background #fff
    border-radius 0.1rem
    width 12rem
    margin 0.25rem auto
    padding 0.35rem
    text-align center
    .ht
      font-size 0.28rem
      padding-bottom 0.2rem
      color #555
    .content
      display flex
      flex-wrap wrap
      a
        width 33.33%
        span
          padding 0.15rem 0
          display block
          font-size 0.2rem
          background #eee
          margin 0 0.1rem 0.1rem 0
.lawyer-intro-rate
  margin 0.1rem 0.8rem 0.6rem
  .lawyer-intro--rates
    display flex
    justify-content center
    align-items center
    flex-direction column
    .item-content
      margin-bottom 0.1rem
    .item-inner
      display flex
      align-items center
      padding 0 0.15rem
      font-size 0.36rem
      color #ccc
      .item-title
        font-size 0.26rem
        color #555
        width 1.4rem
        display flex
        justify-content flex-end
        align-items center
      .starts
        display flex
        align-items center
        .on
          color #ffcc00
        span
          padding-left 0.15rem
          font-size 0.2rem
          color #555
  .lawyer-intro--tip
    text-align center
    padding 0.3rem
    font-size 0.18rem
    color #999
  .lawyer-intro--info
    border-bottom 0.01rem solid #eee
    text-align center
    padding 0 0 0.2rem
    .name
      font-size 0.28rem
      color #808080
    .tel
      font-size 0.36rem
      display flex
      justify-content center
      align-items center
      padding 0.15rem 0
      strong
        padding-left 0.15rem
        font-size 0.48rem
        color #3d69bd
.lawFirm
  // background #ddd
  min-height 100vh
  .lawyer-list
    margin-left -0.15rem
    padding-bottom 0.8rem
    .item
      border 0.01rem solid #eee
      padding 0.25rem
      display flex
      margin-bottom 0.3rem
      &:active
        background #f7f7f7
      .imgs
        width 0.72rem
        height 0.72rem
        background-size cover
        background-position center 0
        flex-shrink 0
        border-radius 50%
        margin-right 10px
      .lawyer-name
        font-size 0.18rem
        color #333
      .lawyer-tell
        font-size 0.14rem
        color #808080
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 1
        overflow hidden
      .lawyer-intro
        font-size 0.14rem
        color #808080
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 1
        overflow hidden
  .lawyer-about
    position fixed
    left 0
    right 0
    bottom 0
    top 1.2rem
    overflow-y scroll
    z-index 2100
    background #ddd
    .lawyer
      padding-bottom 1.2rem
      .btn-zxls
        display flex
        justify-content center
        align-items center
        height 0.6rem
        font-size 0.24rem
        margin 40px 20% 0
      .content
        margin 1rem 0 0.1rem
        border-radius 0.05rem
        position relative
        border-bottom 0.01rem solid #ddd
        .imgs
          position absolute
          top -0.75rem
          left 50%
          margin-left -0.75rem
          width 1.5rem
          height 1.5rem
          border 0.03rem solid #fff
          border-radius 50%
          background-size cover
          background-color #fff
          background-position center 0
          box-shadow 0 0.03rem 0.05rem rgba(0, 0, 0, 0.3)
        .sc
          background #fff
          padding 0.35rem
          border-radius 0 0 0.05rem 0.05rem
          color #808080
          font-size 0.2rem
          ul
            display flex
            flex-wrap wrap
            li
              width 50%
              padding-bottom 20px
        .tel
          display flex
          justify-content center
          align-items center
          padding 0.15rem
          border-radius 0 0 0.05rem 0.05rem
          color #999
          .icon
            color #4caf50
      .body
        background #fff
        padding 0.25rem
        min-height 0.7rem
        color #555
        border-radius 0.05rem
        border-bottom 0.01rem solid #ddd
        .ht
          border-bottom 0.01rem solid #eee
          padding-bottom 0.1rem
          margin-bottom 0.1rem
          font-size 0.24rem
          font-weight bold
        .detail
          padding 0.3rem
          font-size 0.18rem
      .intro
        padding 1.05rem 0.15rem 0.5rem
        border-radius 0.05rem 0.05rem 0 0
        background #1488cc
        /* fallback for old browsers */
        background -webkit-linear-gradient(to right, #2b32b2, #1488cc)
        /* Chrome 10-25, Safari 5.1-6 */
        background linear-gradient(to right, #2b32b2, #1488cc)
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        .name
          display block
          text-align center
          color #fff
          font-size 0.36rem
          margin-bottom 0.05rem
        .lawfir
          padding-top 0.1rem
          color #fff
          opacity 0.6
          text-align center
          font-size 0.18rem
        .rate
          text-align center
          font-size 0.24rem
          color rgba(255, 255, 255, 0.2)
          .on
            color #fff100
          span
            color #fff
            padding 0 0.15rem
  .lawfirm-about
    position fixed
    left 0
    right 0
    bottom 0
    top 1.59rem
    overflow-y scroll
    z-index 2100
    background #ddd
    .container
      background #fff
      margin 0.3rem auto 0.8rem
      padding 0.6rem
    .ht
      font-size 0.32rem
      font-weight bold
      padding 0.3rem
      border-bottom 0.01rem solid #ddd
      margin-bottom 0.3rem
      text-align center
    .detail
      font-size 0.18rem
      padding 0.3rem
      p
        margin-bottom 0.2rem
  .lawfirm-detail
    .lawfirm-detail-content
      position fixed
      top 1.2rem
      right 0
      bottom 0
      left 27%
      background #fff
      z-index 2000
      padding 0.4rem
      overflow-y scroll
      font-size 0.16rem
      .name
        font-size 0.28rem
        padding-bottom 0.2rem
      .more
        padding 0.2rem 0
      .info
        display -webkit-box
        -webkit-box-orient vertical
        -webkit-line-clamp 3
        overflow hidden
        p
          margin-bottom 0
          display none
          &:first-child
            display block
      .ht
        font-size 0.2rem
        color #555
        line-height 1
        border-left 0.05rem solid #558ce1
        padding-left 0.1rem
        margin 0.35rem 0 0.15rem
    .contact
      padding-bottom 0.15rem
      border-bottom 0.01rem solid #ddd
      div
        margin-bottom 0.1rem
        display flex
        align-items center
        span
          color #558ce1
          display inline-flex
          align-items center
    .mask
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      background rgba(0, 0, 0, 0.5)
      z-index 1000
  .lawfirm-container
    display flex
    height 100%
    .left, .right
      height 100%
      overflow-y scroll
    .left
      padding 0.1rem 0 0.2rem
      width 25%
      background #fff
    .right
      padding 0 0 0.2rem
      width 75%
    .lawfirm-list
      padding 0 0.4rem 0.4rem
      .result-ht
        font-size 0.2rem
        padding-bottom 0.2rem
        color #fff
        strong
          color red
      .item
        display block
        background #fff
        margin-bottom 0.2rem
        padding 0.25rem 0.4rem 0.25rem 0.25rem
        font-size 0.16rem
        color #808080
        border-radius 0.05rem
        display flex
        align-items center
        &:active
          background #f7f7f7
        .content
          flex 1
          .name
            color #555
            font-size 0.24rem
            padding-bottom 0.1rem
        .glyphicon
          flex-shrink 0
          font-size 0.24rem
          color #ddd
    .sider
      .ht
        padding 0.2rem
        font-size 0.24rem
        color #808080
      .area-content
        padding 0 0 0.2rem 0.2rem
        a
          margin 0 0.1rem 0.1rem 0
      .search-content
        padding 0 0.2rem
        display flex
        input
          border-radius 0.06rem 0 0 0.06rem
          border-right 0
        .btn
          flex-shrink 0
          border-radius 0 0.06rem 0.06rem 0
</style>
